import { labReportUrl } from '../lib/labReport'

/**
 * A grading-report number that LINKS to the lab's report when we can build a
 * URL for it (IGI → the PDF, GIA → Report Check), and renders as plain text
 * otherwise. One component so every surface — desktop modal, spec sheet, table,
 * mobile detail, public share page — behaves identically. See lib/labReport.
 *
 * `stopPropagation` on the click so a cert link inside a clickable table row
 * opens the report without also toggling/opening the row.
 */
export function CertLink({
  lab,
  certNo,
  className,
  fallback = '—',
}: {
  lab?: string | null
  certNo?: string | null
  className?: string
  fallback?: string
}) {
  const text = certNo?.trim() || fallback
  const url = labReportUrl(lab, certNo)
  if (!url) return <span className={className}>{text}</span>
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={`View ${(lab || 'lab').trim().toUpperCase()} report ${text}`}
      className={`${className ?? ''} underline decoration-dotted underline-offset-2 hover:text-gold-600`.trim()}
      data-testid="cert-link"
    >
      {text}
    </a>
  )
}
